import { render, staticRenderFns } from "./TabelaDesconto.vue?vue&type=template&id=1dc25298&"
import script from "./TabelaDesconto.vue?vue&type=script&lang=js&"
export * from "./TabelaDesconto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports